// Smoothly scroll a month section (by element id) to the top of the viewport so
// the month header/name is visible. Retries a few times over ~1s to settle
// against async layout shifts (late-loading rows/images pushing the target),
// and aborts immediately if the user starts scrolling themselves.
export function smoothScrollToMonth(id: string) {
  if (typeof window === 'undefined') return;

  let attempts = 0;
  let aborted = false;

  const abort = () => {
    aborted = true;
  };
  // Passive listeners so we never block the user's own scroll.
  window.addEventListener('wheel', abort, { passive: true });
  window.addEventListener('touchmove', abort, { passive: true });

  const cleanup = () => {
    window.removeEventListener('wheel', abort);
    window.removeEventListener('touchmove', abort);
  };

  const tick = () => {
    if (aborted) {
      cleanup();
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    attempts += 1;
    if (attempts >= 4 || !el) {
      cleanup();
      return;
    }
    setTimeout(tick, 250);
  };

  // Defer the first attempt one frame so the freshly-rendered list is laid out.
  requestAnimationFrame(tick);
}
